import type { ResponseData } from "@/hooks/request";

// The API reports a failure under detail: a string for an explicit raise, a list
// of field errors when validation rejects the body.
interface ApiErrorBody {
  detail?: unknown;
}

class ApiError {
  // The HTTP status, or the fallback when the response carried none. An aborted
  // request reports status 0, which lands on the fallback too.
  status: number | "Unknown status";
  detail: unknown;

  constructor(response: ResponseData<unknown>) {
    this.status = response?.status || "Unknown status";
    this.detail = (response?.json as ApiErrorBody | null)?.detail;
  }

  // detail is already a string for an explicit raise, so only the validation
  // list needs serialising to reach something displayable.
  get detail_text(): string | undefined {
    if (this.detail === undefined || this.detail === null) {
      return undefined;
    }
    return typeof this.detail === "string" ? this.detail : JSON.stringify(this.detail);
  }
}

export default ApiError;
